export enum GuaranteesEnum {
  RELIABLE_RECEIPT = 'RELIABLE_RECEIPT',
  RELIABLE_DELIVERY = 'RELIABLE_DELIVERY',
}
